import { CommonQuestionKeys, DocumentField } from '@bybeam/platform-types';
import STANDARD_COMPONENTS from '../standards/index.js';
import { makeEduConfig } from './baseConfig.js';

const CONFIG = makeEduConfig();

// Add address to edu config
const personalInfoSection = CONFIG.sections.find(({ key }) => key === 'personalInfo');
personalInfoSection.questionGroups[1].questions.push(
  STANDARD_COMPONENTS.definitions.questions[CommonQuestionKeys.MAILING_ADDRESS],
);

// Add intro/ description to document upload question
const documentsSection = CONFIG.sections.find(({ key }) => key === 'documents');
const documentsSectionField = documentsSection.questionGroups[0].questions[0]
  .fields[0] as DocumentField;

documentsSection.questionGroups[0].questions[0].copy.intro =
  'Please upload supporting documentation related to the challenge area(s) indicated in your application.';

documentsSectionField.copy.description = `
The following types of documentation can be uploaded for our review process (but are not limited to):

- Current signed lease in your name (or your name on the lease) and a current statement of balance owed from your landlord/ rental company
- Current mortgage statement received within 30 days 
- Itemized car repair estimate received within 30 days 
- Car loan payment statement received within 30 days 
- Utility bill received within 30 days 
- Childcare bill received within 30 days 

All documentation should clearly indicate the company name and contact information, along with your name and account information. After you scan a document, please preview it to make sure that all information is easily seen and read, and that no parts of the document are cut off or cannot be seen. 
`;

// Remove bank account question
const yourSituationSections = CONFIG.sections.find(({ key }) => key === 'youAndYourSituation');
yourSituationSections.questionGroups[0].questions =
  yourSituationSections.questionGroups[0].questions.filter(
    (question) => question.key !== 'hasBankAccount',
  );

// Update additional information question
const otherInformationQuestion = yourSituationSections.questionGroups[0].questions.find(
  (question) => question.key === 'otherInformation',
);
otherInformationQuestion.copy.title = 'Additional Information';
otherInformationQuestion.copy.intro =
  'If the expense you are requesting assistance for is more than the Emergency Grant can cover, please share how you plan to cover the remaining balance.';

export default CONFIG;
